import type { ITrackerConstructor, TTrackEvt, ITrackerClass } from '@/types/wiseTracker';
import type { IParamData, IBaseTrackData } from '@/types/DataStore.ts';
import core from '@/core';
import json from '../package.json';
let tracker: ITrackerClass;

const version = json.version;
const wTracker = {
  init(opts: ITrackerConstructor) {
    console.log('index init', opts);
    if (tracker) {
      throw new Error('SDK 重复初始化');
    }
    tracker = core.init(opts);
    console.log('index tracker: ', tracker);
  },
  track(evtName: TTrackEvt, params?: IParamData, eventCode?: string) {
    console.log('evtName: ', evtName);
    tracker.track(evtName, params, eventCode);
  },
  insert(opts: IBaseTrackData) {
    tracker.insert(opts);
  },
  version() {
    console.log('version', version);
    return version;
  },
};
export default wTracker;
